import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const DoubleContinuousPageIcon = props => (
  <SvgIcon {...props}>
    <g>
      <path d="M 19,3 H 5 C 3.9,3 3,3.9 3,5 v 14 c 0,1.1 0.9,2 2,2 h 14 c 1.1,0 2,-0.9 2,-2 V 5 C 21,3.9 20.1,3 19,3 Z" />
    </g>
  </SvgIcon>
);

export default DoubleContinuousPageIcon;
